import React from 'react'
import { Navigate } from 'react-router-dom'
import { Dashboard } from './dashboard/Dashboard'
import { RoomLoadingSpinner } from './daily/components/RoomLoadingSpinner'
import { useSelector } from 'store/hooks/useSelector'
import { HOME_PAGE_PATH } from 'utils/constants'

export const Landing: React.FC = () => {
  const email = useSelector((state) => state.waitingRoomReducer.providerProfile.Email)
  const isLoggedIn = useSelector((state) => state.auth.loggedIn)

  if (!isLoggedIn) {
    return <Navigate to={HOME_PAGE_PATH} replace />
  }
  if (!email) {
    return (
      <div className='tailwind-scoped' style={{ position: 'fixed', inset: 0, zIndex: 999999999 }}>
        <RoomLoadingSpinner contained />
      </div>
    )
  }
  return <Dashboard />
}

export default Landing
